<template>
  <ui-dropper>
    <template #head>
      Categories & Tags
    </template>

    <div v-if="blog && blog.categories" class="border border-t-0 shadow-inner rounded p-4">
      <ui-text
        v-model="dataNewCategory"
        placeholder="New category"
        @keydown.enter="methodKeyDown"
        />

      <div class="flex flex-wrap gap-2 py-2">
        <UiCategoryBadge
          v-for="(category,c) in blog.categories"
          :key="'category_'+c"
          :text="category"
          editable
          @remove="blog.categories.splice(c, 1)"
          />
      </div>
    </div>
  </ui-dropper>
</template>

<script setup lang="ts">
const blog = defineModel<Blog>()

const dataNewCategory = ref('')

const methodKeyDown = async (e: KeyboardEvent) => {
  if(e.key == "Enter" && blog.value) {
    console.log('Enter')
    e.preventDefault()

    if(!blog.value.categories) {
      blog.value.categories = []
    }

    if (dataNewCategory.value.trim() === '') {
      return
    }

    await nextTick()

    // if not already in the list
    if(blog.value.categories.includes(dataNewCategory.value)) {
      return notify({
        text: 'Category already linked',
        type: 'error'
      })
    }

    blog.value.categories.push(dataNewCategory.value)
    dataNewCategory.value = ''
  }
}

</script>
